export const services = [
  {
    id: "home-cleaning",
    name: "Home Cleaning",
    image: "/assets/images/services/home.webp",
    tagline: "Bringing the shine back to your sanctuary",
    description:
      "Maintaining a clean home is essential for both comfort and peace of mind, but finding the time to keep every corner spotless can be challenging. Our professional house cleaning services in Melbourne are designed to take that burden off your shoulders. Whether you need a one-time deep clean, routine maintenance, or a post-party refresh, our team of highly trained cleaners will ensure your home shines from top to bottom. We use eco-friendly, safe cleaning products, giving your space the thorough care it deserves, while keeping your family’s health and safety a priority.",
    faq: [
      {
        q: "How often should I schedule house cleaning?",
        a: "Most clients prefer weekly or fortnightly services, but we offer flexible plans to meet your specific needs.",
      },
      {
        q: "Do I need to be home during the cleaning?",
        a: "No, many clients provide us with access or leave a key, so you don’t need to be present during the cleaning.",
      },
      {
        q: "What areas of my home will be cleaned?",
        a: "We clean all major areas including kitchens, bathrooms, living spaces, and bedrooms. Custom cleaning is also available.",
      },
      {
        q: "Can I request specific cleaning products to be used?",
        a: "Yes, if you have preferred products, let us know, and we can accommodate your request.",
      },
      {
        q: "Do you offer deep cleaning services?",
        a: "Yes, we offer deep cleaning for specific tasks like oven cleaning, inside cabinets, and more.",
      },
      {
        q: "How long does a typical house cleaning take?",
        a: "Cleaning time depends on the size of the house and the level of service required. On average, it takes 2-6 hours.",
      },
      {
        q: "What if I am not satisfied with the cleaning?",
        a: "We offer a satisfaction guarantee. If you're not happy, we will re-clean the area at no additional charge.",
      },
      {
        q: "Can I customize my cleaning schedule?",
        a: "Yes, we offer customizable cleaning schedules including weekly, fortnightly, monthly, or even one-time services.",
      },
      {
        q: "Are your cleaners background-checked and insured?",
        a: "Yes, all our cleaners are thoroughly vetted, background-checked, and fully insured for your peace of mind.",
      },
      {
        q: "Can you clean my home while I'm on vacation?",
        a: "Yes, you can schedule cleaning services while you’re away. We’ll make sure your home is spotless upon your return.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Gutter Cleaning",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "office-cleaning",
    name: "Office Cleaning",
    image: "/assets/images/services/office.webp",
    tagline: "Enhancing your workplace, one clean at a time",
    description:
      "A clean office isn’t just about appearance it directly impacts productivity, employee well-being, and the impression you leave on clients. Our professional office cleaning services in Melbourne are tailored to meet the needs of your business, ensuring your workspace remains clean, organized, and hygienic. From regular daily cleans to more thorough weekly or monthly deep cleans, we pay attention to every detail from workstations to boardrooms and break areas. With a commitment to quality and reliability, our cleaning team will help you maintain an environment that fosters productivity and professionalism.",
    faq: [
      {
        q: "Do you provide cleaning services after business hours?",
        a: "Yes, we offer after-hours and weekend cleaning to avoid disruptions to your business.",
      },
      {
        q: "Can you clean shared office spaces and coworking areas?",
        a: "Absolutely. We specialize in maintaining clean and hygienic shared spaces, including meeting rooms and break areas.",
      },
      {
        q: "How do you ensure confidentiality and security in offices?",
        a: "Our staff is fully vetted, and we follow strict security protocols to ensure your office remains secure.",
      },
      {
        q: "Can I customize my office cleaning plan?",
        a: "Yes, we work with you to create a cleaning schedule that fits your office's specific needs and frequency.",
      },
      {
        q: "Do you offer eco-friendly cleaning options?",
        a: "Yes, we provide green cleaning solutions using eco-friendly, non-toxic products to support a healthy workplace.",
      },
      {
        q: "Do you clean computers and electronic equipment?",
        a: "Yes, we carefully clean electronic equipment, including monitors, keyboards, and phones, using safe, anti-static cleaners.",
      },
      {
        q: "What types of businesses do you serve?",
        a: "We serve all types of businesses, including small offices, corporate buildings, and shared workspaces.",
      },
      {
        q: "How do you handle high-traffic areas like lobbies and kitchens?",
        a: "We pay special attention to high-traffic areas, ensuring they are thoroughly cleaned and disinfected regularly.",
      },
      {
        q: "Can you provide sanitization services for offices?",
        a: "Yes, we offer comprehensive disinfection services to reduce germs, especially in high-touch areas like doorknobs and workstations.",
      },
      {
        q: "Are your office cleaning services available on a contract basis?",
        a: "Yes, we offer both contract-based and one-time cleaning services depending on your office needs.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Gutter Cleaning",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "restaurant-cleaning",
    name: "Restaurant Cleaning",
    image: "/assets/images/services/restaurant.webp",
    tagline: "Serving cleanliness with every dish",
    description:
      "In the food industry, cleanliness is not only a matter of customer satisfaction but also of health and safety compliance. Our specialized restaurant cleaning services are designed to keep your Melbourne restaurant immaculate, from the dining room to the kitchen. We understand the unique demands of hospitality businesses and focus on every detail from grease and grime removal in the kitchen to spotless, inviting dining areas for your patrons. With flexible scheduling, including after-hours services, we ensure your restaurant remains clean, hygienic, and ready for service at all times.",
    faq: [
      {
        q: "What cleaning services do you offer for restaurants?",
        a: "We offer comprehensive cleaning services, including dining areas, kitchens, restrooms, and food prep areas.",
      },
      {
        q: "Do you clean during or after operating hours?",
        a: "We provide flexible cleaning schedules and can clean during off-hours to minimize disruption to your business.",
      },
      {
        q: "Are your cleaning products safe for use in food areas?",
        a: "Yes, we use food-safe cleaning products that are approved for use in kitchens and food preparation areas.",
      },
      {
        q: "Can you clean exhaust hoods and ventilation systems?",
        a: "Yes, we offer specialized cleaning for kitchen exhaust hoods and ventilation systems to meet health standards.",
      },
      {
        q: "Do you offer deep cleaning for restaurant kitchens?",
        a: "Yes, our deep cleaning services include degreasing surfaces, cleaning behind equipment, and disinfecting all surfaces.",
      },
      {
        q: "How often should I schedule cleaning for my restaurant?",
        a: "We recommend daily cleaning for food prep areas and weekly deep cleaning to ensure compliance with health regulations.",
      },
      {
        q: "Do you provide cleaning for front-of-house areas?",
        a: "Yes, we clean dining areas, bars, and restrooms, ensuring a clean and welcoming environment for your guests.",
      },
      {
        q: "Can you handle large-scale cleaning for events and functions?",
        a: "Yes, we offer event cleaning services to help keep your restaurant spotless during and after large gatherings.",
      },
      {
        q: "Do you clean outdoor dining areas?",
        a: "Yes, we clean outdoor seating areas, including tables, chairs, and floors, ensuring they are ready for customers.",
      },
      {
        q: "What happens if a cleaning job doesn't meet my expectations?",
        a: "We offer a satisfaction guarantee and will return to re-clean any area that doesn’t meet your standards at no extra cost.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },

  {
    id: "medical-centres-cleaning",
    name: "Medical Centres Cleaning",
    image: "/assets/images/services/medical.webp",
    tagline: "Sanitizing for safety, cleaning for care",
    description:
      "When it comes to healthcare facilities, cleanliness and hygiene are absolutely essential. Our expert cleaning services for medical centres in Melbourne adhere to the highest industry standards, ensuring a sterile environment for both patients and staff. We specialize in disinfecting high-touch surfaces, waiting rooms, treatment areas, and surgical suites, reducing the risk of contamination and maintaining a safe and professional space. With our trained staff and use of hospital-grade cleaning products, you can trust us to keep your medical centre clean, compliant, and welcoming.",
    faq: [
      {
        q: "Do you follow specific protocols for medical facility cleaning?",
        a: "Yes, we follow strict healthcare cleaning protocols, including the use of hospital-grade disinfectants and proper sanitation techniques.",
      },
      {
        q: "Can you provide cleaning during clinic hours?",
        a: "Yes, we offer flexible cleaning schedules, including during and after clinic hours, to minimize disruption to patient care.",
      },
      {
        q: "Do your cleaners have experience with medical centre cleaning?",
        a: "Yes, our team is trained in medical cleaning, focusing on infection control and hygiene in patient areas.",
      },
      {
        q: "What areas of a medical centre do you clean?",
        a: "We clean patient rooms, waiting areas, treatment rooms, offices, restrooms, and other medical spaces.",
      },
      {
        q: "Do you offer regular disinfection services?",
        a: "Yes, we offer regular disinfection services, focusing on high-touch surfaces like doorknobs, exam tables, and medical equipment.",
      },
      {
        q: "Are your cleaning products safe for use in healthcare settings?",
        a: "Yes, we use medical-grade, non-toxic cleaning products that are safe for patients and staff.",
      },
      {
        q: "How often should a medical centre be cleaned?",
        a: "We recommend daily cleaning and frequent sanitization to maintain a sterile and safe environment for patients and healthcare workers.",
      },
      {
        q: "Can you handle specialized cleaning for operating rooms and labs?",
        a: "Yes, we provide specialized cleaning for operating rooms, laboratories, and other sensitive medical areas.",
      },
      {
        q: "Are your cleaners trained in infection control?",
        a: "Yes, our staff is trained in infection control practices to reduce the risk of cross-contamination and ensure a hygienic environment.",
      },
      {
        q: "Do you provide cleaning services for dental and veterinary clinics?",
        a: "Yes, we offer cleaning services for all types of medical facilities, including dental offices and veterinary clinics.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "warehouse-cleaning",
    name: "Warehouse Cleaning",
    image: "/assets/images/services/industrial.webp",
    tagline: "Maximizing productivity with a clean warehouse",
    description:
      "A clean and organized warehouse is key to ensuring smooth operations and the safety of your staff. Our warehouse cleaning services are tailored to handle the specific challenges that large industrial spaces present. Whether it’s removing dust and debris from high-traffic areas, scrubbing warehouse floors, or maintaining the cleanliness of loading docks and storage spaces, we provide thorough and efficient cleaning to keep your Melbourne warehouse running smoothly. With safety always top of mind, our team works to ensure your space remains clean, organized, and free of potential hazards.",
    faq: [
      {
        q: "How often should a warehouse be cleaned?",
        a: "The frequency depends on the level of activity, but we recommend regular cleaning to maintain safety and hygiene.",
      },
      {
        q: "Can you clean around warehouse equipment and machinery?",
        a: "Yes, our team is trained to clean around industrial equipment without disrupting operations.",
      },
      {
        q: "Do you offer high-level cleaning for warehouse ceilings and rafters?",
        a: "Yes, we provide high-level cleaning services to remove dust and debris from ceilings, beams, and rafters.",
      },
      {
        q: "What types of warehouses do you clean?",
        a: "We clean all types of warehouses, including distribution centers, manufacturing facilities, and storage warehouses.",
      },
      {
        q: "Can you clean warehouse floors and remove oil stains?",
        a: "Yes, we offer specialized floor cleaning services, including scrubbing and degreasing to remove oil and grime.",
      },
      {
        q: "Do you provide cleaning services for loading docks?",
        a: "Yes, we clean loading docks and exterior areas to ensure your entire warehouse is safe and clean.",
      },
      {
        q: "Can you clean high-traffic areas and walkways?",
        a: "Yes, we focus on high-traffic areas to ensure they remain safe and free from dust and debris.",
      },
      {
        q: "Are your cleaning services available for warehouses with hazardous materials?",
        a: "Yes, we are equipped to handle warehouses with specialized cleaning requirements, including hazardous materials.",
      },
      {
        q: "Do you offer one-time or regular warehouse cleaning?",
        a: "We offer both one-time deep cleaning services and ongoing maintenance plans based on your needs.",
      },
      {
        q: "Are your cleaning staff trained in safety protocols for industrial environments?",
        a: "Yes, our team is trained in industry safety standards to ensure safe and efficient cleaning in warehouse environments.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "gym-cleaning",
    name: "Gym Cleaning",
    image: "/assets/images/services/gym.webp",
    tagline: "Clean spaces, healthy workouts",
    description:
      "In a gym environment, cleanliness is paramount to ensuring member safety and satisfaction. Our gym cleaning services in Melbourne are designed to keep your facility hygienic and fresh, from the reception area to the locker rooms and workout spaces. We understand the importance of disinfecting equipment, high-touch surfaces, and communal areas to prevent the spread of germs and bacteria. Our cleaning team works around your schedule to minimize disruption, ensuring your gym is always clean, inviting, and ready for the next workout.",
    faq: [
      {
        q: "How often should gym equipment be cleaned?",
        a: "We recommend daily cleaning and disinfecting of gym equipment to prevent the spread of bacteria and viruses.",
      },
      {
        q: "Do you provide cleaning services for locker rooms and showers?",
        a: "Yes, we offer comprehensive cleaning of locker rooms, showers, and restrooms to maintain hygiene.",
      },
      {
        q: "Can you clean after gym hours?",
        a: "Yes, we offer after-hours cleaning to ensure your gym is spotless and ready for the next day’s members.",
      },
      {
        q: "Do you disinfect high-touch areas like treadmills and weights?",
        a: "Yes, we pay special attention to high-touch surfaces to ensure they are properly disinfected.",
      },
      {
        q: "Are your cleaning products safe for use in fitness environments?",
        a: "Yes, we use non-toxic, eco-friendly products that are safe for gym environments.",
      },
      {
        q: "Do you offer deep cleaning services for gym floors and mats?",
        a: "Yes, we provide deep cleaning services, including floor scrubbing and mat cleaning to remove dirt and sweat.",
      },
      {
        q: "Can you clean group exercise rooms and equipment?",
        a: "Yes, we offer cleaning for group exercise rooms, including mirrors, floors, and exercise equipment.",
      },
      {
        q: "How do you ensure hygiene in high-traffic areas of the gym?",
        a: "We focus on high-traffic areas such as entryways, locker rooms, and equipment areas to maintain cleanliness and hygiene.",
      },
      {
        q: "Do you offer cleaning services for outdoor gym areas?",
        a: "Yes, we also provide cleaning for outdoor workout spaces and equipment.",
      },
      {
        q: "Can you provide regular disinfection services to meet health standards?",
        a: "Yes, we offer routine disinfection services to keep your gym compliant with health and safety regulations.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "child-care-cleaning",
    name: "Childcare & Kindergarten Cleaning",
    image: "/assets/images/services/child.webp",
    tagline: "Caring for cleanliness where it matters most",
    description:
      "Creating a safe, clean, and hygienic environment is essential in childcare and kindergarten settings. Our specialized cleaning services for childcare centres in Melbourne ensure that your facility meets the highest standards of cleanliness and safety. We focus on disinfecting toys, play areas, classrooms, and bathrooms, all while using child-safe, non-toxic cleaning products. With our expert cleaning team, you can rest assured that your centre is a clean and healthy place for children to learn, play, and grow, giving peace of mind to both staff and parents.",
    faq: [
      {
        q: "How often should childcare facilities be cleaned?",
        a: "We recommend daily cleaning and frequent sanitization to maintain a healthy environment for children.",
      },
      {
        q: "Are your cleaning products safe for children?",
        a: "Yes, we use child-safe, non-toxic, and eco-friendly cleaning products in all areas.",
      },
      {
        q: "Do you clean toys and play equipment?",
        a: "Yes, we sanitize toys, play equipment, and surfaces to help prevent the spread of germs.",
      },
      {
        q: "Can you clean during non-operational hours?",
        a: "Yes, we offer flexible cleaning schedules, including after-hours and weekends when children are not present.",
      },
      {
        q: "Do you provide carpet cleaning services for childcare centres?",
        a: "Yes, we offer professional carpet cleaning to remove dirt, stains, and allergens from rugs and carpets.",
      },
      {
        q: "How do you ensure hygiene in classrooms and play areas?",
        a: "We pay special attention to high-touch areas such as tables, chairs, and toys to maintain cleanliness.",
      },
      {
        q: "Do you offer disinfection services for bathrooms and changing areas?",
        a: "Yes, we provide thorough disinfection of bathrooms and diaper-changing areas to ensure they remain hygienic.",
      },
      {
        q: "Can you clean outdoor play areas?",
        a: "Yes, we clean outdoor play equipment and surfaces to ensure they are safe and clean for children.",
      },
      {
        q: "Do you offer deep cleaning services during holidays?",
        a: "Yes, we provide deep cleaning services during holidays and breaks to ensure the center is ready for reopening.",
      },
      {
        q: "Are your cleaners trained in maintaining hygiene in childcare environments?",
        a: "Yes, our team is experienced in childcare cleaning and follows strict hygiene protocols.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Gutter Cleaning",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "bank-cleaning",
    name: "Bank Cleaning",
    image: "/assets/images/services/bank.webp",
    tagline: "Cleaning that reflects your bank’s trust and professionalism",
    description:
      "A clean and professional environment is vital for maintaining trust in a financial institution. Our bank cleaning services in Melbourne are designed to meet the unique needs of your facility, from teller stations to executive offices. We focus on keeping high-traffic areas spotless while maintaining confidentiality and security. Whether you require daily cleaning or more in-depth periodic cleans, our expert team works efficiently to maintain the professional image your clients expect.",
    faq: [
      {
        q: "How often should a bank be cleaned?",
        a: "We recommend daily cleaning for customer-facing areas and regular maintenance throughout the day to keep high-touch areas sanitized.",
      },
      {
        q: "Do you provide cleaning services for ATMs and self-service kiosks?",
        a: "Yes, we offer specialized cleaning for ATMs, kiosks, and other customer service equipment to ensure they are hygienic and safe to use.",
      },
      {
        q: "Can you clean bank offices and staff areas?",
        a: "Yes, we provide cleaning for both public and private areas of the bank, including offices, conference rooms, and break areas.",
      },
      {
        q: "Are your cleaning staff trained in maintaining confidentiality and security in banks?",
        a: "Yes, our cleaners are trained in maintaining confidentiality and follow strict protocols to ensure the security of sensitive areas.",
      },
      {
        q: "Do you offer after-hours cleaning for banks?",
        a: "Yes, we provide after-hours cleaning services to avoid disruption during business hours and maintain privacy.",
      },
      {
        q: "Can you clean bank teller stations and counters?",
        a: "Yes, we offer thorough cleaning of teller stations, customer service counters, and other high-touch areas to ensure they remain clean and sanitized.",
      },
      {
        q: "Do you offer floor cleaning services for banks?",
        a: "Yes, we provide floor cleaning services, including carpet vacuuming, floor mopping, and polishing to maintain a professional appearance.",
      },
      {
        q: "Can you clean glass doors and partitions in banks?",
        a: "Yes, we provide glass cleaning services for entry doors, partitions, and windows to ensure a spotless and clear appearance.",
      },
      {
        q: "Do you offer cleaning for bank vaults and secure areas?",
        a: "Yes, we are experienced in cleaning secure areas such as vaults while adhering to safety and confidentiality protocols.",
      },
      {
        q: "Can you provide cleaning services for multiple branches of a bank?",
        a: "Yes, we offer cleaning services for single branches as well as multiple locations, providing consistent quality across all sites.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "golf-clubs-cleaning",
    name: "Golf Clubs Cleaning",
    image: "/assets/images/services/golf.webp",
    tagline: "Maintaining the greens and the clean",
    description:
      "Your golf club is a place where members come to relax and enjoy the surroundings, so maintaining a clean and inviting environment is crucial. Our cleaning services for golf clubs in Melbourne focus on keeping every part of your facility pristine, from clubhouses and locker rooms to dining areas and lounges. We pay attention to the details that matter, ensuring your members and guests experience the high standards your club is known for. Let us take care of the cleaning so you can focus on delivering a premier golfing experience.",
    faq: [
      {
        q: "How often should a golf club be cleaned?",
        a: "We recommend regular cleaning for clubhouses, restrooms, and dining areas, and deep cleaning for locker rooms and pro shops.",
      },
      {
        q: "Do you offer cleaning services for golf club events?",
        a: "Yes, we provide event cleaning services before and after tournaments, functions, and special events.",
      },
      {
        q: "Can you clean outdoor areas like patios and course facilities?",
        a: "Yes, we clean outdoor spaces such as patios, dining areas, and course-side facilities to ensure they are ready for guests.",
      },
      {
        q: "Are your cleaning products safe for use around golf course environments?",
        a: "Yes, we use eco-friendly products that are safe for both indoor and outdoor areas within the golf club.",
      },
      {
        q: "Do you clean kitchens and dining areas in golf clubs?",
        a: "Yes, we offer cleaning services for kitchens, dining areas, and bars to maintain high hygiene standards.",
      },
      {
        q: "Can you clean locker rooms and restrooms in golf clubs?",
        a: "Yes, we specialize in cleaning locker rooms, restrooms, and changing areas to keep them hygienic and fresh for members.",
      },
      {
        q: "Do you provide cleaning services for golf club offices?",
        a: "Yes, we offer cleaning for administrative offices, pro shops, and other staff areas within the club.",
      },
      {
        q: "Can you clean golf carts and storage areas?",
        a: "Yes, we offer cleaning services for golf carts and storage facilities to ensure they remain in good condition.",
      },
      {
        q: "Do you provide deep cleaning services for off-season maintenance?",
        a: "Yes, we offer deep cleaning during the off-season to prepare your club for the next season’s guests.",
      },
      {
        q: "How do you handle high-traffic areas in the clubhouse?",
        a: "We focus on maintaining cleanliness in high-traffic areas such as entryways, lounges, and dining rooms to ensure a pleasant experience for members.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "supermarkets-cleaning",
    name: "Supermarkets Cleaning",
    image: "/assets/images/services/supermarket.webp",
    tagline: "Clean aisles, fresh impressions",
    description:
      "Supermarkets demand rigorous cleaning standards to ensure both safety and presentation. Our specialized supermarket cleaning services in Melbourne ensure that every part of your store from the aisles to the checkout counters and refrigerated sections remains clean and sanitary. We focus on high-touch areas, food preparation zones, and public spaces to maintain hygiene and improve the overall shopping experience. With our flexible cleaning solutions, your supermarket will always be ready to welcome customers and meet health compliance standards.",
    faq: [
      {
        q: "How often should supermarkets be cleaned?",
        a: "Supermarkets should be cleaned daily, with high-traffic areas like checkout lanes, aisles, and restrooms being maintained throughout the day.",
      },
      {
        q: "Do you clean grocery shelves and displays?",
        a: "Yes, we offer detailed cleaning for shelves, product displays, and refrigerators to ensure food safety and cleanliness.",
      },
      {
        q: "Can you clean supermarket floors and remove stains?",
        a: "Yes, we provide floor cleaning services, including scrubbing and stain removal, for both tiled and carpeted areas.",
      },
      {
        q: "Do you offer cleaning services for back-of-house areas like storage rooms and loading docks?",
        a: "Yes, we clean storage rooms, loading docks, and other back-of-house areas to ensure they meet hygiene standards.",
      },
      {
        q: "Are your cleaning products safe for use in food-handling areas?",
        a: "Yes, we use food-safe, non-toxic cleaning products that are safe for use in areas where food is handled and stored.",
      },
      {
        q: "Can you clean refrigerated areas like deli counters and meat departments?",
        a: "Yes, we offer specialized cleaning for refrigerated and temperature-controlled areas, including deli and meat counters.",
      },
      {
        q: "Do you offer after-hours cleaning services for supermarkets?",
        a: "Yes, we provide after-hours cleaning to minimize disruption and ensure the store is ready for the next business day.",
      },
      {
        q: "Can you clean supermarket restrooms and staff break rooms?",
        a: "Yes, we provide thorough cleaning of restrooms and staff areas to maintain hygiene and a pleasant environment for both customers and employees.",
      },
      {
        q: "Do you provide disinfection services for high-touch areas?",
        a: "Yes, we focus on sanitizing high-touch surfaces like shopping carts, checkout counters, and door handles to prevent the spread of germs.",
      },
      {
        q: "Can you clean large supermarket chains and independent grocers?",
        a: "Yes, we offer cleaning services for both large supermarket chains and small, independent grocery stores.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "retail-shops-cleaning",
    name: "Retail Shops Cleaning",
    image: "/assets/images/services/retail.webp",
    tagline: "Spotless spaces, satisfied shoppers",
    description:
      "A clean and well-presented store creates a positive shopping experience and encourages repeat business. Our retail cleaning services in Melbourne are designed to keep your shop spotless, organized, and visually appealing. From regular daily cleaning to deep cleans before big sales events, we ensure that your retail space looks its best. Whether it’s floors, fitting rooms, or high-traffic areas, our professional cleaning team provides the attention to detail needed to enhance the shopping experience and maintain your brand’s image.",
    faq: [
      {
        q: "How often should retail shops be cleaned?",
        a: "We recommend daily cleaning of floors, display areas, and restrooms to keep the store presentable for customers.",
      },
      {
        q: "Do you offer after-hours cleaning for retail shops?",
        a: "Yes, we offer after-hours cleaning to ensure your shop is clean and ready for the next business day.",
      },
      {
        q: "Can you clean display windows and glass surfaces?",
        a: "Yes, we provide specialized window and glass cleaning services to keep your display areas spotless.",
      },
      {
        q: "Do you offer floor cleaning services for retail spaces?",
        a: "Yes, we offer professional floor cleaning, including vacuuming, mopping, and polishing for all types of flooring.",
      },
      {
        q: "Can you clean fitting rooms and restrooms in retail shops?",
        a: "Yes, we provide thorough cleaning of fitting rooms, restrooms, and back-of-house areas to maintain a clean environment for staff and customers.",
      },
      {
        q: "Do you provide cleaning services for shopping malls?",
        a: "Yes, we clean individual retail shops and larger shopping centers, ensuring common areas and stores remain pristine.",
      },
      {
        q: "Can you clean specialty shops like jewelry stores?",
        a: "Yes, we cater to all types of retail environments, including high-end boutiques and specialty stores.",
      },
      {
        q: "Are your cleaning services customizable for retail stores?",
        a: "Yes, we tailor our services to meet the specific needs of your retail space, including frequency and specific areas of focus.",
      },
      {
        q: "Can you clean behind displays and shelving units?",
        a: "Yes, we offer detailed cleaning behind and around displays, ensuring that all areas of your shop are dirt-free.",
      },
      {
        q: "Do you offer green cleaning solutions for retail shops?",
        a: "Yes, we offer eco-friendly cleaning options for retail spaces to help you maintain a sustainable business.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "shopping-centres-cleaning",
    name: "Shopping Centres Cleaning",
    image: "/assets/images/services/shopping.webp",
    tagline: "Keeping your centre the clean destination for shoppers",
    description:
      "Maintaining cleanliness in a large shopping centre is essential to provide a welcoming environment for shoppers and tenants alike. Our professional shopping centre cleaning services in Melbourne focus on keeping common areas, food courts, restrooms, and individual stores clean and hygienic. We offer flexible cleaning schedules, including after-hours services, to ensure minimal disruption to businesses while keeping the entire complex pristine. Trust us to help you maintain a high standard of cleanliness that enhances the shopping experience and boosts tenant satisfaction.",
    faq: [
      {
        q: "How often should a shopping centre be cleaned?",
        a: "High-traffic areas should be cleaned daily, and common areas and restrooms should be maintained throughout the day.",
      },
      {
        q: "Do you provide cleaning for food courts and dining areas?",
        a: "Yes, we clean food courts and dining areas, ensuring a hygienic space for shoppers to enjoy their meals.",
      },
      {
        q: "Can you clean escalators and elevators in shopping centres?",
        a: "Yes, we offer specialized cleaning for escalators, elevators, and other high-use facilities.",
      },
      {
        q: "Do you provide cleaning for large shopping malls?",
        a: "Yes, we handle cleaning for malls of all sizes, from small shopping centers to large commercial complexes.",
      },
      {
        q: "Can you provide regular restroom cleaning throughout the day?",
        a: "Yes, we offer continuous restroom cleaning services to maintain hygiene during peak shopping hours.",
      },
      {
        q: "Do you offer parking lot cleaning services?",
        a: "Yes, we clean parking lots and outdoor areas, including sweeping, trash removal, and pressure washing.",
      },
      {
        q: "Are your cleaning services available after shopping hours?",
        a: "Yes, we offer after-hours cleaning to ensure the shopping center is clean and ready for the next day’s shoppers.",
      },
      {
        q: "Can you clean common areas like hallways and seating areas?",
        a: "Yes, we provide comprehensive cleaning of hallways, seating areas, and common spaces throughout the shopping center.",
      },
      {
        q: "Do you provide emergency spill clean-up services?",
        a: "Yes, we offer quick-response spill clean-up services to ensure the safety of shoppers and staff.",
      },
      {
        q: "Can you provide specialized cleaning for large retail events?",
        a: "Yes, we offer event cleaning services for special promotions, product launches, and holiday events within the shopping center.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "school-university-cleaning",
    name: "School & University Cleaning",
    image: "/assets/images/services/school.webp",
    tagline: "Learning in a cleaner, safer environment",
    description:
      "Providing a clean and healthy learning environment is essential for both students and staff. Our school and university cleaning services in Melbourne focus on maintaining cleanliness in classrooms, cafeterias, restrooms, and high-traffic areas. We understand the unique needs of educational facilities and work diligently to ensure that your school remains a safe and welcoming place for education. Our team uses eco-friendly products and advanced cleaning techniques to minimize the spread of germs, allowing students to focus on learning in a clean, healthy space.",
    faq: [
      {
        q: "How often should a school or university be cleaned?",
        a: "We recommend daily cleaning for classrooms, restrooms, and high-traffic areas to maintain a healthy environment for students and staff.",
      },
      {
        q: "Can you provide cleaning services during school hours?",
        a: "Yes, we offer flexible cleaning schedules and can clean during or after school hours to minimize disruption.",
      },
      {
        q: "Do you clean gymnasiums and sports facilities?",
        a: "Yes, we offer cleaning services for gymnasiums, locker rooms, and sports facilities within schools and universities.",
      },
      {
        q: "Do you offer disinfection services for high-touch areas?",
        a: "Yes, we focus on sanitizing high-touch surfaces like desks, door handles, and computer equipment to reduce the spread of germs.",
      },
      {
        q: "Are your cleaning products safe for use around children?",
        a: "Yes, we use eco-friendly, non-toxic cleaning products that are safe for students and staff.",
      },
      {
        q: "Do you provide cleaning for special events and school functions?",
        a: "Yes, we offer event cleaning services for school functions, ensuring the venue is spotless before and after the event.",
      },
      {
        q: "Can you clean outdoor areas like playgrounds and sports fields?",
        a: "Yes, we clean outdoor spaces, including playgrounds, courtyards, and sports fields.",
      },
      {
        q: "Do you provide cleaning during school holidays?",
        a: "Yes, we offer deep cleaning services during holidays to ensure the facility is ready for students' return.",
      },
      {
        q: "How do you handle cleaning in sensitive areas like science labs?",
        a: "Our team is trained to clean sensitive areas such as labs, ensuring proper handling of equipment and safety protocols.",
      },
      {
        q: "Can you clean dormitories in universities?",
        a: "Yes, we offer comprehensive cleaning services for university dormitories, including common areas and individual rooms.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "contruction-cleaning",
    name: "Construction / Builders Cleaning",
    image: "/assets/images/services/construction.webp",
    tagline: "From construction site to pristine space",
    description:
      "Once construction is complete, a thorough clean is essential to make the space presentable and ready for use. Our builders cleaning services in Melbourne are designed to remove construction debris, dust, and residues, leaving the site pristine for handover. Whether it's a commercial project or residential development, we clean every corner, from windows to floors, ensuring a flawless finish that reflects the quality of the build. Our post-construction cleaning helps ensure your project is ready for occupancy or the final showcase.",
    faq: [
      {
        q: "What is included in a post-construction cleaning?",
        a: "Our service includes dust removal, debris clearing, window cleaning, and the thorough cleaning of all surfaces, including floors and walls.",
      },
      {
        q: "How soon after construction can you clean?",
        a: "We can start cleaning as soon as construction work is complete, and the site is safe for entry.",
      },
      {
        q: "Do you offer cleaning services for large-scale construction projects?",
        a: "Yes, we handle both small and large-scale projects, including residential builds and commercial developments.",
      },
      {
        q: "Can you remove construction debris?",
        a: "Yes, we remove debris, dust, and leftover materials, ensuring the site is spotless and ready for use.",
      },
      {
        q: "Do you provide cleaning for new home builds before handover?",
        a: "Yes, we specialize in final cleaning for new homes, ensuring they are ready for handover to new owners.",
      },
      {
        q: "Can you clean windows and exterior surfaces after construction?",
        a: "Yes, we offer thorough window cleaning and can clean external surfaces to remove construction dust and dirt.",
      },
      {
        q: "How long does a post-construction cleaning take?",
        a: "The duration depends on the size of the project, but we typically complete the cleaning within 1-3 days.",
      },
      {
        q: "Do you offer deep cleaning for renovated spaces?",
        a: "Yes, we provide deep cleaning for renovated areas, ensuring that every corner is free of dust and construction debris.",
      },
      {
        q: "Are your cleaners experienced in handling construction sites?",
        a: "Yes, our team is trained in post-construction cleaning and follows strict safety protocols to ensure a thorough job.",
      },
      {
        q: "Do you provide cleaning for commercial construction projects?",
        a: "Yes, we offer cleaning services for commercial construction sites, including office buildings, retail spaces, and industrial facilities.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Gutter Cleaning",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
  {
    id: "hotel-apartments-cleaning",
    name: "Hotel & Apartments Cleaning",
    image: "/assets/images/services/hotel.webp",
    tagline: "Luxury in every corner, cleanliness in every room",
    description:
      "In the hospitality industry, first impressions are everything. Our professional cleaning services for hotels and apartment complexes in Melbourne are designed to create a spotless, welcoming environment for your guests. We provide a comprehensive range of services, from routine housekeeping to deep cleans, ensuring that every area from lobbies and common spaces to guest rooms is kept to the highest standard of cleanliness. Whether you manage a boutique hotel or a large apartment complex, our team delivers a meticulous clean that enhances the guest experience and maintains the prestige of your property.",
    faq: [
      {
        q: "Do you offer daily housekeeping for hotels and serviced apartments?",
        a: "Yes, we provide daily housekeeping services to ensure rooms are always clean and ready for guests.",
      },
      {
        q: "Can you provide cleaning for short-term rental apartments?",
        a: "Yes, we specialize in quick turnaround cleaning for Airbnb and other short-term rental properties.",
      },
      {
        q: "Do you clean common areas in hotels and apartment buildings?",
        a: "Yes, we clean lobbies, hallways, elevators, and other shared spaces to maintain a high standard of cleanliness.",
      },
      {
        q: "Can you provide deep cleaning services between guest stays?",
        a: "Yes, we offer deep cleaning services to ensure each room is thoroughly cleaned between guests.",
      },
      {
        q: "Are your cleaners trained in hospitality cleaning?",
        a: "Yes, our team is experienced in hotel and apartment cleaning and follows industry best practices.",
      },
      {
        q: "Do you offer linen and laundry services?",
        a: "Yes, we can provide linen changing and laundry services for hotels and serviced apartments.",
      },
      {
        q: "Can you clean hotel conference rooms and event spaces?",
        a: "Yes, we offer cleaning for conference rooms, banquet halls, and event spaces before and after events.",
      },
      {
        q: "How often should common areas in apartment buildings be cleaned?",
        a: "High-traffic areas should be cleaned daily, and deep cleaning should be done regularly to maintain hygiene.",
      },
      {
        q: "Do you provide green cleaning options for hotels?",
        a: "Yes, we offer eco-friendly cleaning solutions to support sustainability in the hospitality industry.",
      },
      {
        q: "Can you clean hotel kitchens and restaurant areas?",
        a: "Yes, we provide specialized cleaning for hotel kitchens, restaurants, and bar areas.",
      },
    ],
    tasks: [
      "Vacuuming",
      "Dusting",
      "Bathrooms & Toilets",
      "Kitchen & Dining Area",
      "Surfaced Wiped",
      "Mirrors & Walls",
      "Pressure Wash Cleaning",
      "Window Blinds",
      "Carpet/Steam Cleaning",
      "Furniture",
      "Mopping of All Floor Surfaces",
      "Cobweb Clean",
      "Detail/Deep Clean",
      "Cleaning of Feminine Hygiene Facilities",
      "Removal of Rubbish & Replacement of Bin Liners",
    ],
  },
];

export const servicesHome = [
  {
    id: "home-cleaning",
    name: "Home Cleaning",
    image: "/assets/images/services/home.webp",
  },
  {
    id: "office-cleaning",
    name: "Office Cleaning",
    image: "/assets/images/services/office.webp",
  },
  {
    id: "restaurant-cleaning",
    name: "Restaurant Cleaning",
    image: "/assets/images/services/restaurant.webp",
  },

  {
    id: "medical-centres-cleaning",
    name: "Medical Centres Cleaning",
    image: "/assets/images/services/medical.webp",
  },
  {
    id: "warehouse-cleaning",
    name: "Warehouse Cleaning",
    image: "/assets/images/services/industrial.webp",
  },
  {
    id: "gym-cleaning",
    name: "Gym Cleaning",
    image: "/assets/images/services/gym.webp",
  },
  {
    id: "child-care-cleaning",
    name: "Child Care Cleaning",
    image: "/assets/images/services/child.webp",
  },
  {
    id: "bank-cleaning",
    name: "Bank Cleaning",
    image: "/assets/images/services/bank.webp",
  },
  {
    id: "golf-clubs-cleaning",
    name: "Golf Clubs Cleaning",
    image: "/assets/images/services/golf.webp",
  },
  // {
  //   id: "pressure-wash-cleaning",
  //   name: "Pressure Wash Cleaning",
  //   image: "/assets/images/services/pressure.png",
  // },

  // {
  //   id: "glass-cleaning",
  //   name: "Glass Cleaning",
  //   image: "/assets/images/services/glass.png",
  // },
  // {
  //   id: "end-of-lease-cleaning",
  //   name: "End of Lease Cleaning",
  //   image: "/assets/images/services/lease.png",
  // },
];

export const servicesAll = [
  ...servicesHome,
  {
    id: "supermarkets-cleaning",
    name: "Supermarkets Cleaning",
    image: "/assets/images/services/supermarket.webp",
  },
  {
    id: "retail-shops-cleaning",
    name: "Retail Shops Cleaning",
    image: "/assets/images/services/retail.webp",
  },
  {
    id: "shopping-centres-cleaning",
    name: "Shopping Centres Cleaning",
    image: "/assets/images/services/shopping.webp",
  },
  {
    id: "school-university-cleaning",
    name: "School & University Cleaning",
    image: "/assets/images/services/school.webp",
  },
  {
    id: "contruction-cleaning",
    name: "Construction/Builders Cleaning",
    image: "/assets/images/services/construction.webp",
  },
  {
    id: "hotel-apartments-cleaning",
    name: "Hotel & Apartments Cleaning",
    image: "/assets/images/services/hotel.webp",
  },
];

export const servicesOptions = services.map((service) => ({
  value: service.id,
  label: service.name,
}));
